import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DataStorageService } from '../data-storage.service';

@Component({
  selector: 'app-dialog-show',
  templateUrl: './dialog-show.component.html',
  styleUrls: ['./dialog-show.component.css']
})
export class DialogShowComponent implements OnInit {

  public title: string;
  public message: string;

  constructor(public dialogRef: MatDialogRef<DialogShowComponent>,
    private translate: TranslateService,
    private dataStorage: DataStorageService) { 
      translate.setDefaultLang('en');
      translate.use(dataStorage.getLanguage());
    }

  ngOnInit() {
    let tempTitle = this.title;
    this.title = "";
    let tempMessage = this.message;
    this.message = "";
    this.translate.get(tempTitle).subscribe(data => {
      this.title = data;
    });
    this.translate.get(tempMessage).subscribe(data => {
      this.message = data;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dialog-show/dialog-show.component.ts